@if (itemSize) {
  <cdk-virtual-scroll-viewport #viewPort data-test-id="scrollable" class="h-full" [itemSize]="itemSize">
    <!-- templateCacheSize: 0 is used here on purpose. Otherwise, it introduces CD glitches -->
    <ng-container *cdkVirtualFor="let itemId of itemIds; templateCacheSize: 0">
      <ng-container *ngTemplateOutlet="itemWrapperTemplate; context: { itemId }"></ng-container>
    </ng-container>
  </cdk-virtual-scroll-viewport>
}

<div class="calculator absolute -left-full -bottom-full">
  <ng-container #calculator></ng-container>
</div>

<ng-template #itemWrapperTemplate let-itemId="itemId">
  @if (createItemTemplateContext(itemId); as itemContext) {
    <div
      [id]="itemId"
      class="item-wrapper {{ gapClass }}"
      [ngClass]="{ 'focused-via-scroll': itemContext.isFocusedViaScroll }"
    >
      <ng-container *ngTemplateOutlet="itemTemplate; context: itemContext"></ng-container>
    </div>
  }
</ng-template>
